export default __webpack_public_path__ + "static/media/dra-debora.3a4fdc60.png";